<template>
  <div class="jc-page-content">
    <div class="jc-panel jc-panel-padding">
      <div :class="statusColor">
        <div class="jc-box-icon">
          <i :class="statusIcon"></i>
        </div>

        <div class="jc-box-content">
          <slot name="status">
            <h3>{{ title }}</h3>

            <h4>{{ subhead }}</h4>

            <p>{{ describe }}</p>

            <slot name="operate"></slot>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sk-status',
  props: {
    status: {
      type: String,
      require: true,
    },
    title: [String, Number],
    // 主标题
    subhead: [String, Number],
    // 副标题
    describe: [String, Number], // 描述
  },

  components: {},
  mixins: [],
  data() {
    return {}
  },
  watch: {},
  computed: {
    statusIcon() {
      switch (this.status) {
        case 'success': {
          return 'jc-icon-circle-check'
        }
        case 'fail': {
          return 'jc-icon-circle-cross'
        }
        case 'warn': {
          return 'jc-icon-circle-warning'
        }
        case 'information': {
          return 'jc-icon-information'
        }
        default: {
          return 'jc-icon-information'
        }
      }
    },
    statusColor() {
      switch (this.status) {
        case 'success': {
          return 'jc-container-result jc-result-success'
        }
        case 'fail': {
          return 'jc-container-result jc-result-danger'
        }
        case 'warn': {
          return 'jc-container-result jc-result-warning'
        }
        case 'information': {
          return 'jc-container-result jc-result-information'
        }
        default: {
          return 'jc-container-result jc-result-information'
        }
      }
    },
  },
  mounted() {},
  created() {},
  filters: {},
  methods: {},
}
</script>

<style>
.jc-container-result {
  margin-left: 200px;
  margin-right: 200px;
  margin-top: 100px;
  margin-bottom: 150px;
}
.jc-container-result .jc-box-icon {
  float: left;
}
.jc-container-result .jc-box-icon i {
  font-size: 60px;
}
.jc-container-result .jc-box-content {
  margin-left: 104px;
}
.jc-container-result .jc-box-content h3 {
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 22px;
}
.jc-container-result .jc-box-content h5 {
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 4px;
}
.jc-container-result .jc-box-content p {
  line-height: 18px;
  margin-bottom: 4px;
  color: #999999;
}
.jc-container-result .jc-box-content .jc-box-action {
  margin-top: 30px;
}
.jc-result-info.jc-container-result .jc-box-icon i {
  color: #2aafff;
}
.jc-result-success.jc-container-result .jc-box-icon i {
  color: #1bca69;
}
.jc-result-danger.jc-container-result .jc-box-icon i {
  color: #ff3a3a;
}
</style>
